import { string, StringSchema } from 'yup'
import { FieldValidateProps } from '../../../../lib/types/components/validate'
import {
  applyMinMaxLength,
  resolveCustomValidator,
  TDrupal_FieldType_Validate,
} from '../../../../lib/functions/webform_validation_functions/webform_validation_functions'
import { applyPatternIfApplicable } from '../../../../lib/functions/utils_functions'

export const validateTextField = (props: FieldValidateProps) => {
  const {
    yupObject,
    defaultValues,
    key,
    required,
    defaultFieldValues,
    requiredMessage,
    field,
    rhfCustomValidators,
    minLengthMessage,
    maxLengthMessage,
  } = props

  if (field?.['#readonly']) {
    defaultValues[key] = defaultFieldValues.textfield
    return
  }

  const type = field?.['#type'] as TDrupal_FieldType_Validate | undefined

  let baseSchema = string()

  baseSchema = applyMinMaxLength(
    baseSchema,
    field,
    minLengthMessage,
    maxLengthMessage
  )

  baseSchema = applyPatternIfApplicable({
    schema: baseSchema,
    field,
  })

  if (required) {
    baseSchema = baseSchema.required(requiredMessage)
  }

  yupObject[key] =
    resolveCustomValidator<StringSchema<string | undefined>>(
      rhfCustomValidators,
      key,
      type,
      props
    ) ?? baseSchema

  defaultValues[key] = defaultFieldValues.textfield
}
